module.exports = __webpack_public_path__ + "static/media/healthy_coffee.21cabc7a.jpg";